import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'bs-quick-bet-each-way-total-stake',
    templateUrl: './quick-bet-each-way-total-stake.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-each-way-total-stake.component.scss'],
    standalone: false,
})
export class QuickBetEachWayTotalStakeComponent {
    @Input() totalStake: number;

    readonly totalStakeText: string;

    constructor(sitecore: Sitecore) {
        this.totalStakeText = sitecore.betslip.messages.TotalStake;
    }
}
